import { createPassage } from "@osuecampus/branching-stories";

/**
 * Fields for the workbook completion passage (e.g. id `lab-complete`).
 * - `terminal: true` avoids the branching-stories machine auto-entering the `back`
 *   dead-end for passages with no choices (non-terminal + no choices → `back`).
 * - `setFlags` records this passage in `visitedPassageIds` during entry effects, so
 *   `useStoryEngine` does not depend on `updateFlags` while the machine is in `back`
 *   or `final` (those states do not handle `UPDATE_FLAGS` in @osuecampus/branching-stories).
 *
 * @param {string} passageId - Must match the passage `id` (usually `lab-complete`).
 * @returns {{ terminal: boolean, setFlags: (prev: object) => object }}
 */
export function completionPassageExtras(passageId) {
  return {
    terminal: true,
    setFlags: (prev) => {
      const raw = prev?.visitedPassageIds;
      const v = Array.isArray(raw) ? [...raw] : [];
      if (!v.includes(passageId)) {
        return { visitedPassageIds: [...v, passageId] };
      }
      return {};
    }
  };
}

/**
 * Like `createPassage`, but preserves `progressLabel` for manifest-derived progress steps.
 * `@osuecampus/branching-stories` strips unknown keys from the returned passage object.
 *
 * @param {Object} def
 * @param {string} [def.progressLabel]
 * @returns {Object}
 */
export function createLabPassage(def) {
  const { progressLabel, ...rest } = def;
  const passage = createPassage(rest);
  return progressLabel != null ? { ...passage, progressLabel } : passage;
}
